import React from 'react';
import LinkComp from '../LinkComp';
import svgAngleDoubleLeft from '../../svgs/angle-double-left.svg';
import svgAngleDoubleRight from '../../svgs/angle-double-right.svg';
import Icon from '../Icon';
import PropTypes from 'prop-types';

const Paginate = (props) => {
	const page = props.page ? Number(props.page) : 1;
	const itemCount = props.originalItemCount ? props.originalItemCount : props.itemCount;
	let hasMore = null;

	// Display nothing if there is less than 1 page of items.
	if (!props.itemCount || (props.totalCount !== false && itemCount === props.totalCount) || (page === 1 && itemCount < props.limit)) {
		return null;
	}

	if (props.totalCount !== false) {
		// If totalCount is false then it was probably too inefficient to get the count for this query.
		hasMore = props.limit * page < props.totalCount;
	} else {
		// There are probably more results if the itemCount matches the request count.
		hasMore = itemCount > 0 && itemCount === props.limit;
	}

	const prevQuery = Object.assign({}, props.query, {page: page - 1});
	const nextQuery = Object.assign({}, props.query, {page: page + 1});

	if (prevQuery.page <= 1) {
		delete prevQuery.page;
	}

	if (!hasMore) {
		delete nextQuery.page;
	}

	return (
		<div className='Paginate'>
			<LinkComp to={{pathname: props.pathname, query: prevQuery}} rel="prev" disabled={page <= 1}>
                <div className='button-new negative'>Previous</div>
			</LinkComp>
			<LinkComp to={{pathname: props.pathname, query: nextQuery}} rel="next" disabled={!hasMore}>
                <div className='button-new positive'>Next</div>
			</LinkComp>
		</div>
	);
};

Paginate.propTypes = {
    pathname: PropTypes.string.isRequired,
	query: PropTypes.object.isRequired,
	limit: PropTypes.number.isRequired,
	page: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
	totalCount: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
	itemCount: PropTypes.number.isRequired,
    originalItemCount: PropTypes.number,
};

export default Paginate;